const map = {
	"./modal-attribution-new.hbs": 81659,
	"./modal-confirm-copy-content.hbs": 53243,
	"./modal-copy-svg-from-search-list-not-premium-user.hbs": 10134,
	"./modal-craft-info.hbs": 14026,
	"./modal-funnel-premium-add-icon.hbs": 45125,
	"./modal-funnel-premium-freePng.hbs": 31361,
	"./modal-license.hbs": 63560,
	"./modal-palette-not-premium-user.hbs": 2446,
	"./modal-premium.hbs": 1670,
	"./modal-remove-palette.hbs": 15451
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94358;